import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import { clearToast } from '../actions/toast';

import Snackbar from '@catalytic/pushbot-ui/Snackbar';

const toast = createSelector(state => state.toast || {}, toast => toast || {});

export const toastError = createSelector(toast, ({ error }) => !!error);

export const toastMessage = createSelector(
  toast,
  ({ message }) => message || ''
);

export class SnackbarContainer extends PureComponent {
  static displayName = 'SnackbarContainer';
  static propTypes = {
    /**
     * Indicates the snackbar body should use the error color scheme
     */
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    /**
     * Toast settings for what to show in the snackbar
     */
    toast: PropTypes.shape({
      action: PropTypes.string,
      error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
      message: PropTypes.string,
      onActionClick: PropTypes.func,
      open: PropTypes.bool,
      autoHideDuration: PropTypes.number
    }),
    /**
     * Fired when the Snackbar is requested to be closed
     */
    onRequestClose: PropTypes.func
  };

  render() {
    const { error: errorProp, toast = {}, onRequestClose } = this.props;
    const {
      action,
      error: errorToast,
      message = '',
      onActionClick,
      open = false,
      autoHideDuration
    } = toast;
    const error = errorProp || errorToast;
    return (
      <Snackbar
        {...{
          action,
          error,
          message,
          onActionClick,
          open,
          onRequestClose,
          autoHideDuration
        }}
      />
    );
  }
}

export default connect(
  // eslint-disable-next-line no-unused-vars
  (state, props) => ({
    toast: state.toast,
    error: toastError(state),
    message: toastMessage(state)
  }),
  dispatch => ({
    onRequestClose: nextProps => dispatch(clearToast(nextProps))
  })
)(SnackbarContainer);



// WEBPACK FOOTER //
// ./js/Snackbar/SnackbarContainer.js